import React from 'react'
import Particles from 'react-particles-js'
import "./particles2.css";

function Particles2() {
    return (
        <div className="party2">
          <div className="partik">
              <Particles
                        params={{
                            particles: {
                                number: {
                                    value: 50,
                                    density: {
                                        enable: true,
                                        value_area: 500,
                                    }
                                },
                                color: {
                                    value: "black"
                                },
                                height: "100vh",

                                shape: {
                                    type: "circle",
                                    stroke: {
                                        width: 10,
                                        color: "white",
                                    }
                                }
                            }
                        }}
              />

              
         </div>
         
           
        </div>
    )
}

export default Particles2
